import React from "react";
import { FormattedMessage } from "react-intl";
import { Space, Row } from "@masterteam/mt-design-react";

import KPIStatusIndicator from "../../KPIStatusIndicator";

import "./style.scss";

const Statuses = ({ thresholds }) => {
  return (
    <Row size="large" justify="center" className="statuses-container">
      <Space align="center">
        <div>
          <FormattedMessage id="common.kpi-status" /> :
        </div>

        <Space size="medium">
          {thresholds.map((_item, index) => (
            <KPIStatusIndicator item={_item} key={index} />
          ))}
        </Space>
      </Space>
    </Row>
  );
};

export default Statuses;
